import React from 'react';
import { shallowEqual } from 'react-redux';
import { rtDebug } from '..';
import { useAppSelector } from '../../../../../hooks/hooks';
import useRenderDebug from '../../../../../hooks/useRenderDebug';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import FiltersRender from './FiltersRender';

const Responsive = ({ tableName }: { tableName?: string }) => {
  const { name } = useResponsiveTableContext(tableName);

  const nonAdditionalFilters = useAppSelector((global) => {
    const state = global.responsiveTableSlice[name];
    return (
      state?.filters.filter(
        (current) =>
          !current.asAdditional &&
          !!state.columns.find((search) => search.name === current.column),
      ) ?? []
    );
  }, shallowEqual);

  useRenderDebug(rtDebug.filters.responsive, 'Responsive.tsx', {
    name,
    nonAdditionalFilters,
  });

  return (
    <FiltersRender
      className="responsiveFilters"
      filters={nonAdditionalFilters}
    />
  );
};

export default React.memo(Responsive);
